import { Component, ChangeDetectionStrategy } from '@angular/core';
import { LibTableRecordActionComponent } from '@tuain/ng-forms';
import { tuainFormsBaseModules, tuainBaseComponents } from '@components/tuain.modules';

@Component({
  standalone: true,
  selector: 'app-upload-action',
  imports: [...tuainFormsBaseModules, ...tuainBaseComponents],
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // La visibilidad se aplica en el host y no con un `@if` alrededor del `<ng-content>`: el
  // contenido proyectado no se puede volver a proyectar si se destruye.
  host: {
    style: 'display:block; margin-top:auto;',
    '[style.display]': "visible() ? 'block' : 'none'",
  },
})
export class AppUploadActionComponent extends LibTableRecordActionComponent {
  private uploadedFile: File | null = null;

  onFileReceived(file: File) {
    this.uploadedFile = file;
    this.onActivate();
  }

  override onActivate() {
    const tableEvent = {
      actionCode: this.action?.actionCode ?? '',
      recordId: this.recordId,
      recordData: { ...this.recordData, file: this.uploadedFile },
    };
    this.actionSelected.emit(tableEvent);
  }
}
